import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Col, Row, Select, Icon } from 'antd';
import { sanitizerTexto } from '../../../util/utilerias';
import { openNotification } from '../../../util/notificaciones';
import CatalogoRequest from '../../../services/Catalogo';
import CapturaCiclicaRequest from '../../../services/CapturaCiclica';
import { get_id } from '../../../util/IdUser';
import { esBarras, getSegmento } from '../../../util/generics';
import DetalleDiferenciaCiclicoModal from './DetalleDiferenciaCiclicoModal';
import { ShowMenuItem } from '../../../util/ShowMenuItem';
import { roles } from '../../../util/Roles';
import moment from 'moment';
moment.locale('es')

const { Option } = Select;

export default class DiferenciasCiclico extends Component {
    state = {
        arrListaDiferencias: [],
        cargando: false,
        arrDrives: [],
        driveSelected: undefined,
        disable_combo_drive: false,

        detalleModalVisible: false,
        detalleModalIdInventario: null,

        pageMain: 1,
        pageSizeMain: 20,
        totalCountMain: 0,
    }

    componentDidMount = () => {
        const segmento = getSegmento()
        if (!segmento || esBarras() || !ShowMenuItem([roles.AdminCatalogos])) {
            this.props.history.push({ pathname: "/" })
            return
        }

        this.cargarDrivesUsuario()
    }

    cargarDrivesUsuario = () => {
        CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
            const arrDrives = response.data || []
            this.setState({ arrDrives }, () => {
                if (arrDrives.length === 1) {
                    this.setState({ driveSelected: arrDrives[0].id }, this.onChangeDrive)
                }
                if (!arrDrives.length) {
                    openNotification("El usuario no tiene asignado un punto de venta, favor de contactar al Administrador.", "Aviso")
                }
            })
        }).catch(() => {
            openNotification("Ha ocurrido un error al listar los puntos de venta del usuario.", "Error")
        })
    }

    onChangeDrive = () => {
        const { driveSelected } = this.state
        if (!driveSelected) {
            this.setState({ arrListaDiferencias: [], totalCountMain: 0 })
            return
        }

        this.setState({ pageMain: 1 }, this.cargarDiferencias)
    }

    cargarDiferencias = () => {
        const { driveSelected, pageMain, pageSizeMain } = this.state
        if (!driveSelected) return

        this.setState({ cargando: true }, () => {
            CapturaCiclicaRequest.ListarDiferencias(driveSelected, pageMain, pageSizeMain).then(response => {
                const responseData = response.data?.data || {};
                this.setState({
                    arrListaDiferencias: responseData.diferencias || [],
                    totalCountMain: responseData.count || 0,
                    cargando: false,
                })
            }).catch(() => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar las diferencias del drive seleccionado.", "Error")
            })
        })
    }

    financial(x) {
        if (x === null || x === undefined || x === '') return '-'
        return Number.parseFloat(x).toFixed(2);
    }

    verDetalle = (record) => {
        this.setState({ detalleModalVisible: true, detalleModalIdInventario: record.id })
    }

    cerrarDetalle = () => {
        this.setState({ detalleModalVisible: false, detalleModalIdInventario: null })
    }

    render() {
        const columnas = [
            {
                title: "Fecha de captura",
                dataIndex: "fecha_captura",
                key: "fecha_captura",
                render: fecha => <span>{moment(fecha).format("DD/MM/YYYY, h:mm a")}</span>
            },
            {
                title: "Turno",
                dataIndex: "turno_nombre",
                key: "turno_nombre",
                render: (value) => <span>{value || '-'}</span>
            },
            {
                title: "Usuario",
                dataIndex: "usuario_captura",
                key: "usuario_captura",
            },
            {
                title: "Frecuencia",
                dataIndex: "tipo_frecuencia",
                key: "tipo_frecuencia",
                render: (value) => (
                    <span style={{ fontWeight: 'bold' }}>
                        {value === 'diario' ? 'Diario' : 'Semanal'}
                    </span>
                )
            },
            {
                title: "Sobrante",
                dataIndex: "sobrante",
                key: "sobrante",
                align: 'center',
                render: (value) => <span>{this.financial(value)}</span>
            },
            {
                title: "Faltante",
                dataIndex: "faltante",
                key: "faltante",
                align: 'center',
                render: (value) => <span>{this.financial(value)}</span>
            },
            {
                title: 'Acciones',
                dataIndex: 'acciones',
                key: 'acciones',
                render: (_, record) => (
                    <Tooltip placement="top" title="Ver detalle">
                        <Button icon="eye" className="btnEditar" onClick={() => this.verDetalle(record)}></Button>
                    </Tooltip>
                )
            }
        ]

        return (
            <Card id="ParentSize"
                title={'Diferencias en Cíclico'}
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                            <Col span={8}>
                                <Tooltip placement="top" title="Punto de venta">
                                    <div className="center">Punto de venta:</div>
                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={this.state.arrDrives?.length > 1}
                                        showSearch
                                        disabled={this.state.disable_combo_drive}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.driveSelected}
                                        onChange={(value) => this.setState({ driveSelected: value }, this.onChangeDrive)}
                                    >
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map((obj) => (
                                                <Option key={obj.id} value={obj.id}>{obj.nombre}</Option>
                                            ))
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(record) => record.id}
                            columns={columnas}
                            dataSource={this.state.arrListaDiferencias}
                            pagination={{
                                current: this.state.pageMain,
                                pageSize: this.state.pageSizeMain,
                                total: this.state.totalCountMain,
                                onChange: (page, pageSize) => {
                                    this.setState({ pageMain: page, pageSizeMain: pageSize }, this.cargarDiferencias)
                                },
                                onShowSizeChange: (page, pageSize) => {
                                    this.setState({ pageMain: 1, pageSizeMain: pageSize }, this.cargarDiferencias)
                                },
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '50', '100']
                            }}
                        />
                    </Spin>
                </div>

                <DetalleDiferenciaCiclicoModal
                    visible={this.state.detalleModalVisible}
                    idInventario={this.state.detalleModalIdInventario}
                    onClose={this.cerrarDetalle}
                />
            </Card>
        )
    }
}
